import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

/**
 * پیام‌ها رو یکی‌یکی با تاخیر نشون می‌ده.
 * بین پیام‌های bot یه typing indicator کوتاه نشون می‌ده.
 */
export function useTypedChat(script, { enabled = true } = {}) {
  const containerRef = useRef(null);
  const inView = useInView(containerRef, { once: true, amount: 0.3 });

  const [visible, setVisible] = useState([]);
  const [typing, setTyping] = useState(false);

  useEffect(() => {
    if (!enabled || !inView) return;

    let cancelled = false;
    const timeouts = [];

    const wait = (ms) =>
      new Promise((res) => {
        const id = setTimeout(res, ms);
        timeouts.push(id);
      });

    const run = async () => {
      await wait(500);
      for (let i = 0; i < script.length; i++) {
        if (cancelled) return;
        const msg = script[i];

        if (msg.from === "bot") {
          setTyping(true);
          await wait(700);
          if (cancelled) return;
          setTyping(false);
        }

        setVisible((prev) => [...prev, { ...msg, id: i }]);
        await wait(msg.from === "bot" ? 1900 : 1400);
      }
    };

    run();

    return () => {
      cancelled = true;
      timeouts.forEach(clearTimeout);
    };
  }, [script, enabled, inView]);

  return { containerRef, visible, typing };
}